import { _APIHandler } from "../utils/helper";

let baseUrl = "warehouses";
export const fetchWarehouses = (queryParams) => _APIHandler.get(`${baseUrl}`, { params: queryParams });
export const fetchWarehouseLists = () => _APIHandler.get(`${baseUrl}/lists`);
export const fetchWarehouse = (id) => _APIHandler.get(`${baseUrl}/${id}`);
export const createWarehouse = (data) => _APIHandler.post(`${baseUrl}`, data,);
export const updateWarehouse = (id, data) => _APIHandler.put(`${baseUrl}/${id}`, data);
export const deleteWarehouse = (id) => _APIHandler.delete(`${baseUrl}/${id}`);